import { TApplicationState } from 'shared/types/redux';

export function priceRelevanceSelector(state: TApplicationState) {
  return state.newbuilding.relevanceInfo;
}
